import pSelect from "./black/select";

new pSelect('#p-select');

promokit.layer({
    el: '#layer-rule',
    buttons: '.p-btn__rule',
    render:true
});

window.layer_coupon = promokit.layer({
    el: '#layer-coupon',
    // buttons: '.p-btn__coupon',
    render:true
});

let page = promokit.page({
    caution: '#section-caution',
    cnb: true, //true, false
    topButton: true, //true, false
    footer: {
        theme: 'black' //'black', 'white'
    },
    headerButton: {
        el: '.header-button',
        home: true,
        event: true,
        sns: true,
        theme: 'black' //'black', 'white'
    }
});

$('.promokit-layer__close--inside').on('click',function () {
    layer_coupon.close();
});


// WEBPACK FOOTER //
// ./src/js/black.js